<template>
  <div class="file-view" v-show="showPreview">
     <div class="file-container" :style="{padding: fileType == 3 ? '20px' : ''}">
      <iframe
        v-show="fileType == 1 || fileType == 2"
        :src="url"
        frameborder="0"
        class="file-iframe"
      ></iframe>
      <div class="txt-container" v-html="txtHtml" v-show="fileType == 3">
        
      </div>
    </div>
    <div class="close-btn" title="关闭" @click="handleClose">
      <span class="dialog-close iconfont icon-sys-shibai" ></span>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: "HzxmanageFilePreview",

  data() {
    return {
      showPreview: false,
      url: "",
      fileType: null,
      txtHtml: "",
    };
  },

  mounted() {},

  methods: {
    init() {
      this.showPreview = true;
      if(this.fileType == 3) {
        axios.get(this.url, { responseType: 'text' }).then( res => {
          const txtHtml = res.replace(/\n/g, "<br>")
          this.txtHtml = txtHtml
        }).catch(err => {
          console.error("获取文件内容 err: ", err)
        }) 
      }
    },
    handleClose() {
      setTimeout(() => {
        this.$destroy(true);
        this.$el && this.$el.parentNode.removeChild(this.$el);
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>

.file-view {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background-color: rgba($color: #000000, $alpha: 0.7);
  z-index: 99999999;
  display: flex;
  justify-content: center;
  align-items: center;
  .file-container {
    width: 900px;
    height: 100vh;
    background-color: #ffffff;
    box-sizing: border-box;
    .file-iframe {
      width: 100%;
      height: 100%;
    }
    .txt-container{
      height: 100%;
      box-sizing: border-box;
      padding: 10px;
      overflow-y: auto;
    }
  }
  .close-btn {
    position: absolute;
    right: 40px;
    top: 40px;
    cursor: pointer;
    .dialog-close{
        color: #ffffff;
        font-size: 40px;
    }
  }
}
</style>
